import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class StaffService {
  constructor(staffBaseUrl, getCustomAccessToken) {
    this.staffApi = new Api(staffBaseUrl);
    if (typeof getCustomAccessToken === "function") {
      this.staffApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.staffApi.addInterceptor(accessTokenInterceptor);
    }
  }
  async getEndShiftReports(params) {
    const url = "/api/v1/endshift/summary-report";
    const { data } = await this.staffApi.get(url, { params: __spreadValues({}, params) });
    return data.data;
  }
  async confirmEndShift(body) {
    const url = "/api/v1/endshift/confirm";
    const { data } = await this.staffApi.put(url, body);
    return data.data;
  }
  async getListSites(params) {
    const url = "/api/v1/sites";
    const { data } = await this.staffApi.get(url, { params: __spreadValues({}, params) });
    return data;
  }
  async getListTerminalsBySeller(sellerId, page, pageSize) {
    const url = `/api/v1/sellers/${sellerId}/terminals`;
    const { data } = await this.staffApi.get(url, {
      params: { page, pageSize }
    });
    return data == null ? void 0 : data.data;
  }
  async getListPromotions(query) {
    const url = `/api/v1/promotions`;
    const { data } = await this.staffApi.get(url, { params: __spreadValues({}, query) });
    return data == null ? void 0 : data.data;
  }
  async getPlatformConfig(platformId, sellerId) {
    const url = `api/v1/platforms/config`;
    const { data } = await this.staffApi.get(url, {
      params: { platformId, sellerId }
    });
    return data == null ? void 0 : data.data;
  }
}

export { StaffService };
